import {HttpErrorResponse} from '@angular/common/http';

/**
 * Extrahiert eine für Nutzer:innen lesbare Fehlermeldung aus einer HttpErrorResponse - die
 * vollständigste der drei zuvor unabhängig voneinander implementierten Varianten
 * (SickLeaveService, EmployeeService, DatevAuthStatusComponent), konsolidiert an einer Stelle.
 *
 * Reihenfolge (erste zutreffende Regel gewinnt):
 * 1. status === 0   -> Server nicht erreichbar (Netzwerkfehler/CORS/Timeout)
 * 2. status === 401 -> nicht angemeldet
 * 3. status === 403 -> keine Berechtigung
 * 4. error.error?.message vorhanden -> vom Backend mitgelieferte Nachricht (statt generischem Fallback)
 * 5. sonst -> generische "Server meldet Fehler: <status>. <message>"-Nachricht
 */
export function extractHttpErrorMessage(error: HttpErrorResponse): string {
    if (error.status === 0) {
        return 'Der Server ist nicht erreichbar. Bitte überprüfen Sie Ihre Internetverbindung oder versuchen Sie es später erneut.';
    } else if (error.status === 401) {
        return 'Sie sind nicht angemeldet. Bitte melden Sie sich an.';
    } else if (error.status === 403) {
        return 'Sie haben keine Berechtigung für diese Aktion.';
    } else if (error.error?.message) {
        return error.error.message;
    } else {
        return `Server meldet Fehler: ${error.status}. ${error.message}`;
    }
}
